import { render, staticRenderFns } from "./blocking.vue?vue&type=template&id=2db722c0&"
import script from "./blocking.vue?vue&type=script&lang=js&"
export * from "./blocking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports